export default {
    campaign: {
        name: "CarSaver",
        title: "Upgrade Program",
    },
    home: {
        hero: {
            title: "<h2>CarSaver</h2>",
        },
        upgrade: {
            title: "The BMW Upgrade Program",
            message: "Upgrade from home gives you the power to shop for a new or used car online, right from your home.",
            buttonText: "See your upgrade offers",
            pinText: "Welcome to the Ultimate BMW Upgrade Experience",
            pinTextNew: "Hi {0},<br> Welcome to your Personalized BMW Upgrade Experience",
            technicalPhoneNumber: "+1 (888) 574-4041"
        },
        valueProps: {
            title: "The Easiest Way to Upgrade to a Newer Car",
            items: ["Get into a newer car more often", "Enjoy the newest technology", "Upgrade with as little as $0 down"],
        },
        payments: {
            name: "BMW"
        },
        promotionBanner: {
            title: "Exclusive BMW Financial Services Loyalty Offers",
            subtitle: "Enjoy programs specially designed for returning owners from BMW Financial Services.",
            promotionalDisclaimer: "*Programs only apply to specific, new vehicles. Qualifying new vehicles must be " +
                "leased or retail financed through BMW Financial Services, LLC. Interest will accrue during the " +
                "payment deferral period. Customer needs to meet the credit requirements as specified for " +
                "BMW Financial Services, LLC.",
            calendarIconText: "<b>{0} Days to First Payment</b> for New BMW Retail Financing.",
            costIcon: "<b>36 Month Loyalty Lease Rates</b> on Select New BMWs.",
            loyaltyIcon: "<b>Loyalty Credits</b> on Select New BMW’s Leased or Retail Financed"
        },
        newHomeSection: {
            videoId: 'wistia_async_unultkp933',
        },
        inventorySection: {
            title: "Find Your Next <b>Ultimate</b> Driving Machine",
            inventory: [
                {
                    title: 'SUV',
                    imgClass: 'home-suv',
                    linkText: 'Start Upgrading',
                    filters: { bodyStyles: ['suv'] }
                },
                {
                    title: 'Coupe & Convertible',
                    imgClass: 'home-coupe-convertible',
                    linkText: 'Start Upgrading',
                    filters: { bodyStyles: ['coupe', 'convertible'] }

                },
                {
                    title: 'Sedan',
                    imgClass: 'home-sedan',
                    linkText: 'Start Upgrading',
                    filters: { bodyStyles: ['sedan'] }

                },
                {
                    title: 'EV',
                    imgClass: 'home-ev',
                    linkText: 'Start Upgrading',
                    filters: { fuelTypes: ['Electric'] }
                },
            ],
            primaryCtaText: 'View all Upgrade Inventory'
        },
        offerSection: {
            title: "Unlock <b>Exclusive</b> Loyalty Offers",
            offers: [
                {
                    title: 'Search new and pre-owned inventory.',
                    imgClass: 'loyalty-search-new',
                },
                {
                    title: 'Take advantage of programs specially designed for returning owners.*',
                    imgClass: 'loyalty-take-advantage',
                },
                {
                    title: 'Seamless & transparent.',
                    imgClass: 'loyalty-transparent',
                },
            ],
            primaryCtaText: 'View Your Offers',
            footerDescription: '*Eligibility is based on your current loan and vehicle and is subject' +
                ' to BMW Financial Services NA, LLC, credit requirements. Zero-dollar down payment will' +
                ' depend on the actual trade-in value of your vehicle. You may be required to make a down payment if' +
                ' vehicle trade-in value is lower than initially estimated.'
            },
    },
    deal: {
        testDrive: "Schedule Test Drive",
        primaryCta: "Contact Dealer",
        startUpgrade: "Contact Dealer",
        shopperText: "Client Loyalty Specialists",
        disclaimerFee: '495'
    },
    softPull: {
        form: {
            pageTitle: "Time to calculate your offers",
            pageSubtitle:
                "You are about to receive your personalized upgrade offers on vehicles " +
                "that include all taxes, dealer fees and your trade (if applicable)",
        },
        creditAppText: ["Get pre-qualified for finance programs",
            "Check eligibility for additional rebates and incentives",
            "Verify payoff information on your trade-in (if available)",
            "Compare cash, finance, and lease offers (including all taxes and fees)"]
    },
};
